import request from './request'

export const login = (data) => {
  return request({
    url: '/jf-tech/v1/login',
    method: 'POST',
    data
  })
}

// 服务站登录
export const loginFwz = (data) => {
  return request({
    url: '/rame/gsfms/yzm/fwz_login',
    method: 'POST',
    data
  })
}
// export const loginGly = (data) => {
//   return request({
//     url: '/rame/gsfms/gsf_login',
//     method: 'POST',
//     data
//   })
// }
// 验证码
// export const loginFwzCode = (data) => {
//   return request({
//     url: '/rame/gsfms/fwz_login/code',
//     method: 'POST',
//     data
//   })
// }

// 统一登录
export const loginGly = (data) => {
  return request({
    url: '/rame/gsfms/login',
    method: 'POST',
    data
  })
}
// 统一 输入验证码
// api/rame/gsfms/login/code
export const loginFwzCode = (data) => {
  return request({
    url: '/rame/gsfms/login/code',
    method: 'POST',
    data
  })
}
// 仓储中心登陆
export const loginkingdee = (data) => {
  return request({
    url: '/rame/kingdee/login',
    method: 'POST',
    data
  })
}
